<div class="card-container">
  <div class="mat-elevation-z8 mt-4">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="last_updated_at"
      matSortDirection="desc"
      class="port-table"
      [hidden]="!tableLoaded"
    >
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let element">
          @if (!readOnly) {
            <mat-checkbox
              [checked]="element.selected"
              color="primary"
              (change)="onSelect($event, element)"
            ></mat-checkbox>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td mat-cell *matCellDef="let element">
          <span
            class="cursor-pointer underline-on-hover ms-2"
            (click)="onStockClick(element)"
            >{{ element.name }}</span
          >
          @if (element.description) {
            <app-info-popover
              [company]="element"
              [title]="'Description - ' + element.name"
              [content]="element.description"
              (click)="closeOtherInfo(element)"
            ></app-info-popover>
          }
          @if (element.shared_with_users_concat) {
            <mat-icon
              color="primary"
              class="cursor-pointer align-middle"
              [matTooltip]="'Shared with: ' + element.shared_with_users_concat"
              >group</mat-icon
            >
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          class="text-center"
        >
          Status
        </th>
        <td mat-cell *matCellDef="let element" class="text-center">
          @if (element.status == 1) {
            <span class="status-computing">
              <mat-spinner
                [diameter]="16"
                class="d-inline-block align-middle"
              ></mat-spinner>
              <span class="ms-1 align-middle">Computing</span>
            </span>
          }
          @if (element.status == 2) {
            <span
              class="status-failed"
              matTooltip="No feasible portfolio could be generated with the selected constraints. Please review and adjust the constraints."
              matTooltipPosition="above"
            >
              <mat-icon class="align-middle status-failed-icon">error</mat-icon>
              <span class="ms-1 align-middle">Failed</span>
            </span>
          }
          @if (element.status == 3) {
            <span class="status-ready">
              <mat-icon class="align-middle status-ready-icon"
                >check_circle</mat-icon
              >
              <span class="ms-1 align-middle">Ready</span>
            </span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="shared_by">
        <th mat-header-cell *matHeaderCellDef class="text-center">Shared by</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          {{ element.user && element.user.name ? element.user.name : "" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="last_updated_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
          Last Updated
        </th>
        <td mat-cell *matCellDef="let element" class="text-end">
          @if (element.status == 3) {
            {{ element.last_updated | utcToLocalTime: "short" }}
          } @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
          Created
        </th>
        <td mat-cell *matCellDef="let element" class="text-end">
          {{
            element.created_at
              ? (element.created_at | utcToLocalTime: "short")
              : "In progress"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="currency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
          Currency
        </th>
        <td mat-cell *matCellDef="let element" class="text-end">
          {{ element.currency ? element.currency.name : "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="asset_count">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">
          # Assets
        </th>
        <td mat-cell *matCellDef="let element" class="text-end">
          {{ element.security_count }}
        </td>
      </ng-container>

      <ng-container matColumnDef="action" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon class="color-mid-grey">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            @if (!element.readonly) {
              <button mat-menu-item [routerLink]="['portfolio', element.id]">
                Edit Portfolio
              </button>
            }
            @if (element.readonly) {
              <button
                mat-menu-item
                [routerLink]="['portfolio-view', element.id]"
              >
                View
              </button>
            }
            <button mat-menu-item (click)="onClickCopy(element)">
              Duplicate portfolio
            </button>
            <button mat-menu-item (click)="onClickInit(element)">Init</button>
            <button mat-menu-item (click)="onExportPdf(element)">
              Export PDF
            </button>
            @if (!element.readonly) {
              <button mat-menu-item (click)="deleteItem(element)">
                Delete
              </button>
            }
            @if (element.readonly && element.visibility == sharedVisivility) {
              <button mat-menu-item (click)="unshareItem(element)">
                Delete share
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <app-info infoIndex="1"></app-info>
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="float-end" [matMenuTriggerFor]="menu">
            <mat-icon class="color-mid-grey">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onClickInit(element)">Init</button>
            <button mat-menu-item (click)="onEditConstraints(element)">
              Edit constraints
            </button>
            <button mat-menu-item (click)="onExportPdf(element)">
              Export PDF
            </button>
            <button
              mat-menu-item
              (click)="onRemoveClick(element)"
              class="border-primary rounded-pill"
            >
              Delete
            </button>
            <button
              mat-menu-item
              (click)="onEdit(element)"
              class="border-primary rounded-pill float-end"
            >
              Edit
            </button>

            <button
              mat-menu-item
              (click)="onDuplicate(element)"
              class="border-primary rounded-pill float-end"
            >
              Duplicate
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>
    <!--     <mat-paginator [pageSizeOptions]="[10, 20, 100]" showFirstLastButtons></mat-paginator> -->
  </div>
</div>
